
    import './styles.scoped.css';
    export default {
  "dropdown-footer": "awsui_dropdown-footer_vm8qf_lavh7_9",
  "dropdown-content": "awsui_dropdown-content_vm8qf_lavh7_14",
  "token-trigger": "awsui_token-trigger_vm8qf_lavh7_18",
  "token-trigger-invalid": "awsui_token-trigger-invalid_vm8qf_lavh7_43",
  "token-trigger-warning": "awsui_token-trigger-warning_vm8qf_lavh7_55",
  "token-trigger-disabled": "awsui_token-trigger-disabled_vm8qf_lavh7_67",
  "token-trigger-readonly": "awsui_token-trigger-readonly_vm8qf_lavh7_77",
  "token-list": "awsui_token-list_vm8qf_lavh7_83",
  "token-list-item": "awsui_token-list-item_vm8qf_lavh7_97",
  "token-input-wrapper": "awsui_token-input-wrapper_vm8qf_lavh7_101",
  "pill-icon": "awsui_pill-icon_vm8qf_lavh7_105",
  "pill-icon-open": "awsui_pill-icon-open_vm8qf_lavh7_121",
  "token-trigger-container": "awsui_token-trigger-container_vm8qf_lavh7_125",
  "measurement-container": "awsui_measurement-container_vm8qf_lavh7_130",
  "overflow-panel": "awsui_overflow-panel_vm8qf_lavh7_141",
  "overflow-panel-list": "awsui_overflow-panel-list_vm8qf_lavh7_175",
  "overflow-panel-item": "awsui_overflow-panel-item_vm8qf_lavh7_185",
  "token-overflow-pill": "awsui_token-overflow-pill_vm8qf_lavh7_192"
};
  